// extracted by mini-css-extract-plugin
module.exports = {"bug":"charters-module--bug--1uoPu","table":"charters-module--table--2UWI5","mobileInfo":"charters-module--mobileInfo---B8L1"};